// removed by extract-text-webpack-plugin
module.exports = {"textDanger":"_3W62fO0wNumsCXOw9GhDiU","spaceLeft":"eXibRwzjBajfOGM12Dlmx","spaceBoth":"_35Ck7oi6Tp6udykCSc7mgS","spaceRight":"_1cEnovrO2KG9DRJyIF7ZsI","errorMessage":"_1KRrsBpVyw1CK4iUHWdZUv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OfferTakeForm.scss
// module id = 1223
// module chunks = 0